import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

function About() {
    return (
        <Box sx={{mx: "auto", mt: 4}}>
            <Paper elevation={2} sx={{p: 4}}>
                <Typography variant="h5" gutterBottom>
                    How to use RIMap-RISC :
                </Typography>
                <Typography variant="body1" paragraph>
                    1. Select a pair: a Gencode v46 protein-coding transcript and a MiRBase microRNA.<br/>
		    2. Start your query by either:<br/>
		    &nbsp;&nbsp;a. setting a detection mode, or<br/>
		    &nbsp;&nbsp;b. filling the parameters and clicking <strong>MAP/RUN</strong>.<br/>
		    3. If the selected pair has been computed previously, results will appear instantly. For new pairs, computation typically completes in under one minute and rarely exceeds three minutes.<br/>
                    4. View the results displayed below the Query panel.<br/>
                    5. Use <strong>DOWNLOAD INTERACTIONS</strong> to save your results.<br/>
		    6. Follow the <strong>TarBase-v9.0</strong> link to access experimental evidence for your selected pair.<br/>
		    <br/>
		    <i>Note:</i> RIMap-RISC is incrementally populated as users submit new requests.

                </Typography>
                <Typography variant="h5" gutterBottom>
                    Definitions and methods used in RIMap-RISC :
                </Typography>
                <Box sx={{mt: 3, textAlign: "center"}}>
                    <img
                        src="/images/RIMapRISCInfo.png"
                        alt="RIMap-RISC Information"
                        style={{
                            maxWidth: "100%",
                            padding: 12,
                            borderRadius: 8,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                        }}
                    />
                </Box>
            </Paper>
        </Box>
    );
}

export default About;
